module.exports = __webpack_public_path__ + "img/logo-horizontal-on-white.fd034da7.png";